/**
 * @file     AntiSpamHoneypot.tsx
 * @purpose  Shared bot-catch input that stays near its form and is ignored by browser autofill and password managers.
 */
'use client';

import type { ChangeEvent } from 'react';
import Box from '@mui/material/Box';
import { honeypotSx } from '@/services/anti-spam';

type AntiSpamHoneypotProps = {
  onValueChange: (value: string) => void;
  value?: string;
};

export function AntiSpamHoneypot({
  onValueChange,
  value,
}: AntiSpamHoneypotProps): React.ReactElement {
  return (
    <Box
      component="input"
      type="text"
      value={value}
      tabIndex={-1}
      autoComplete="off"
      aria-hidden="true"
      data-lpignore="true"
      data-1p-ignore="true"
      onChange={(event: ChangeEvent<HTMLInputElement>) => onValueChange(event.target.value)}
      sx={honeypotSx}
    />
  );
}
